// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.carousel {
  display: flex;
  max-width: 100%;
}
.carousel_slides-container {
  transition: all 1s ease-in-out;
  animation: fade 1s ease-in-out forwards;
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  position: relative;
  object-fit: contain;
  border: none;
}
.carousel_image-container {
  width: 100%;
  height: 350px;
  background-size: cover;
  transform: translateY(-1px);
  border-radius: 4px;
  overflow: hidden;
}
.carousel_image-container_img {
  width: 100%;
  height: 100%;
  -webkit-backface-visibility: hidden;
  transition: all 1s ease-in-out;
  animation: slideInFrames 3s ease-in-out;
  border-radius: 4px;
  overflow: hidden;
}
@media screen and (max-width: 1680px) {
  .carousel_image-container {
    height: 250px;
  }
}
@media (max-width: 768px) {
  .carousel_image-container {
    width: 100%;
    height: 500px;
  }
}
@media (max-width: 560px) {
  .carousel_image-container {
    height: 300px;
  }
}
@media (max-width: 414px) {
  .carousel_image-container {
    height: 300px;
  }
}
.carousel_dot-container {
  display: flex;
  align-items: center;
  justify-content: center;
  left: 550px;
  margin-top: -5px;
  z-index: 2;
}
@media (max-width: 768px) {
  .carousel_dot-container {
    margin-top: 10px;
  }
}
.carousel_rectangle {
  margin-left: 5px;
  margin-right: 5px;
  z-index: 2;
}
.carousel_rectangle-dot {
  height: 4px;
  width: 4px;
  margin: 0 2px;
  background-color: white;
  border-radius: 50%;
  display: inline-block;
  transition: background-color 0.6s ease;
  z-index: 2;
}
@media (max-width: 768px) {
  .carousel_rectangle-dot {
    background-color: #e0e0e0;
  }
}
.carousel_rectangle-dot:active {
  animation: fade 1s ease-in-out forwards;
  width: 24px;
  height: 4px;
  border-radius: 2px;
  background-color: white;
  margin-left: 5px;
  margin-right: 5px;
  z-index: 2;
}
@media (max-width: 768px) {
  .carousel_rectangle-dot:active {
    background-color: black;
  }
}

@keyframes fade {
  from {
    opacity: 0.4;
  }
  to {
    opacity: 1;
  }
}
@keyframes slideInFrames {
  from {
    opacity: 0;
    transform: translateX(20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Carousel/Carousel.scss"],"names":[],"mappings":"AAEA;EACE,aAAA;EACA,eAAA;AADF;AAGE;EACE,8BAAA;EACA,uCAAA;EACA,aAAA;EACA,WAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;AADJ;AAIE;EACE,WAAA;EACA,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,kBAAA;EACA,gBAAA;AAFJ;AAII;EACE,WAAA;EACA,YAAA;EACA,mCAAA;EACA,8BAAA;EACA,uCAAA;EACA,kBAAA;EACA,gBAAA;AAFN;AAKI;EAlBF;IAmBI,aAAA;EAFJ;AACF;AAII;EAtBF;IAuBI,WAAA;IACA,aAAA;EADJ;AACF;AAGI;EA3BF;IA4BI,aAAA;EAAJ;AACF;AAEI;EA/BF;IAgCI,aAAA;EACJ;AACF;AAEE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;EACA,UAAA;AAAJ;AACI;EAPF;IAQI,gBAAA;EAEJ;AACF;AACE;EACE,gBAAA;EACA,iBAAA;EACA,UAAA;AACJ;AAEE;EACE,WAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,qBAAA;EACA,sCAAA;EACA,UAAA;AAAJ;AACI;EATF;IAUI,yBAAA;EAEJ;AACF;AAAI;EACE,uCAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,uBAAA;EACA,gBAAA;EACA,iBAAA;EACA,UAAA;AAEN;AADM;EATF;IAUI,uBAAA;EAIN;AACF;;AACA;EACE;IACE,YAAA;EAEF;EAAA;IACE,UAAA;EAEF;AACF;AACA;EACE;IACE,UAAA;IACA,2BAAA;EACF;EACA;IACE,UAAA;IACA,wBAAA;EACF;AACF","sourcesContent":["@use \"../../shared/shared.scss\" as ljc;\n\n.carousel {\n  display: flex;\n  max-width: 100%;\n\n  &_slides-container {\n    transition: all 1s ease-in-out;\n    animation: fade 1s ease-in-out forwards;\n    display: flex;\n    width: 100%;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n    object-fit: contain;\n    border: none;\n  }\n\n  &_image-container {\n    width: 100%;\n    height: 350px;\n    background-size: cover;\n    transform: translateY(-1px);\n    border-radius: 4px;\n    overflow: hidden;\n\n    &_img {\n      width: 100%;\n      height: 100%;\n      -webkit-backface-visibility: hidden;\n      transition: all 1s ease-in-out;\n      animation: slideInFrames 3s ease-in-out;\n      border-radius: 4px;\n      overflow: hidden;\n    }\n\n    @media screen and (max-width: ljc.$mobile16) {\n      height: 250px;\n    }\n\n    @media (max-width: ljc.$mobile76) {\n      width: 100%;\n      height: 500px;\n    }\n\n    @media (max-width: ljc.$mobile56) {\n      height: 300px;\n    }\n\n    @media (max-width: ljc.$mobile41) {\n      height: 300px;\n    }\n  }\n\n  &_dot-container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    left: calc(1100px / 2);\n    margin-top: -5px;\n    z-index: 2;\n    @media (max-width: ljc.$mobile76) {\n      margin-top: 10px;\n    }\n  }\n\n  &_rectangle {\n    margin-left: 5px;\n    margin-right: 5px;\n    z-index: 2;\n  }\n\n  &_rectangle-dot {\n    height: 4px;\n    width: 4px;\n    margin: 0 2px;\n    background-color: white;\n    border-radius: 50%;\n    display: inline-block;\n    transition: background-color 0.6s ease;\n    z-index: 2;\n    @media (max-width: ljc.$mobile76) {\n      background-color: #e0e0e0;\n    }\n\n    &:active {\n      animation: fade 1s ease-in-out forwards;\n      width: 24px;\n      height: 4px;\n      border-radius: 2px;\n      background-color: white;\n      margin-left: 5px;\n      margin-right: 5px;\n      z-index: 2;\n      @media (max-width: ljc.$mobile76) {\n        background-color: black;\n      }\n    }\n  }\n}\n\n@keyframes fade {\n  from {\n    opacity: 0.4;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes slideInFrames {\n  from {\n    opacity: 0;\n    transform: translateX(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
